import type { LevelCatalog, Shops } from "@highmarch/app";
import type { HubApi } from "../../features/registry";

/**
 * How the Shops screen reaches the game (features/shops.ts sets it once at boot, like dealsLink.ts): the catalog's
 * `Shops` use cases, the clock and the hub. Null in tests and before boot: then `openShops` opens nothing.
 */
export interface ShopsLink {
  readonly catalog: LevelCatalog;
  readonly shops: Shops;
  now(): number;
  /** Save and redraw the hub (its pills and the Shops badge). */
  changed(): void;
  /** The hub while it is up (null in a level): the shops open only from the hub. */
  hub: HubApi | null;
}

let link: ShopsLink | null = null;
export function setShopsLink(l: ShopsLink | null): void { link = l; }
export function shopsLink(): ShopsLink | null { return link; }
